import * as React from 'react';

function SvgEuro(props) {
  return (
    <svg viewBox="0 0 10 14" fill="none" {...props}>
      <path
        d="M6.242 2.016c-.734 0-1.336.218-1.804.656-.464.437-.774 1.099-.93 1.984H7.07V5.86H3.39l-.015.352v.43l.016.304h3.187v1.196H3.523c.334 1.625 1.282 2.437 2.844 2.437.745 0 1.508-.161 2.29-.484v1.586c-.683.317-1.477.476-2.384.476-1.255 0-2.276-.344-3.062-1.031-.781-.688-1.292-1.682-1.531-2.984H.492V6.945h1.063l-.016-.289v-.289l.016-.508H.492V4.656h1.172c.198-1.307.695-2.333 1.492-3.078C3.953.833 4.982.461 6.242.461c1.042 0 1.974.23 2.797.687L8.383 2.61c-.802-.395-1.516-.593-2.14-.593z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgEuro;
